import { Injectable } from "@angular/core";

import { Resource } from "@impulse/sdp-shared-models";

import { ApiGatewayService } from "../../common/api-gateway/api-gateway.service";

@Injectable()
export class ApplicationsService {
	private _data: Resource[] = [];

	constructor(
		private apiGatewayService: ApiGatewayService
	) { }

	/**
	 * Lazily load the application data.
	 */
	public async getData() {
		if (!this._data) {
			await this.refresh();
		}
		return this._data;
	}

	/**
	 * Force a reload of the data, returning the new data after loading.
	 */
	public async refresh() {
		this._data = await this.apiGatewayService.getAllApplications();

		for (const application of this._data) {
			application.access.users = application.access.users.sort((a, b) => {
				return a.localeCompare(b);
			});
		}

		return this._data;
	}

	/**
	 * Clears the local data, if any, so that it must reload from the server the next time.
	 */
	public invalidate() {
		this._data = [];
	}
}
